import React from "react";
import { YhBox } from "@/components/YhBox";
import { SearchItem } from "@/components/YhPageHeader/item";
import { Row } from "antd";
import { ISearchField, ISearchProp, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { useWriteoffModel } from "./writeoffModel";
import { useDetailModel } from "../detailModel";
import useGlobalModel from "@/model/globalModel";

const statusDs = [
    {
        value: 0,
        label: '待申请'
    },
    {
        value: 1,
        label: '待对方确认'
    },
    {
        value: 2,
        label: '对方不认可'
    },
    {
        value: 3,
        label: '待财务确认'
    },
    {
        value: 4,
        label: '对方已驳回'
    },
    {
        value: 5,
        label: '待财务审核'
    },
    {
        value: 6,
        label: '财务已驳回'
    },
    {
        value: 7,
        label: '待最终审核'
    },
    {
        value: 8,
        label: '最终审核通过'
    },
    {
        value: 9,
        label: '最终已驳回'
    }
]

export const WriteoffSearchBox = () => {
    const {
        onSearch,
        onReset,
        searchParam,
        updateSearchParam,
        loadData
    } = useWriteoffModel()
    const { customerUserDs } = useDetailModel()
    const { unit } = useGlobalModel()

    const searchProp: ISearchProp = {
        searchValues: searchParam,
        triggerSearch: true,
        handleSearch: (val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val }),
        onChange: (data) => {
            updateSearchParam(data)
        }
    }
    const searchFields: (ISearchProp & ISearchField)[] = [
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "账户",
            fieldName: "accountCode",
            size: "small",
            disabled: false,
            options: customerUserDs?.filter(item => item.unitCode === unit?.code),
            ...searchProp
        },

        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "状态",
            fieldName: "status",
            size: "small",
            disabled: false,
            options: statusDs,
            ...searchProp
        },
        // {
        //     type: SearchTypeEnum.RangePicker,
        // xxl: 4,
        // span: 4,
        //     placeholder: "起止",
        //     fieldName: "time",
        //     size: "small",
        //     disabled: false,
        //     ...searchProp,
        //     onChange: (data) => {
        //         let newData = {
        //             writeoffTimeRange: data.time[0] !== '' && data.time[1] !== '' ? {
        //                 startTime: data.time[0] + ' 00:00:00',
        //                 endTime: data.time[1] + ' 23:59:59'
        //             } : undefined,
        //             ...data
        //         }
        //         updateSearchParam(newData)
        //     }
        // },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "检索",
            fieldName: "searchBtn",
            onClick: onSearch,
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "重置",
            fieldName: "resetBtn",
            onClick: onReset,
        },
    ]

    return (
        <YhBox>
            <Row
                gutter={[20, 10]}
                justify="start"
                style={{ padding: "0 15px" }}
            >
                {searchFields?.map(
                    (el, index) => <SearchItem
                        key={index}
                        {...el} />
                )}
            </Row>
        </YhBox>
    )
}
